import { observable, action, runInAction, computed } from 'mobx'
import { cancellationRequests } from '@services/api'
import { StoreExt } from '@utils/reactExt'
import { buildCancellationFilterArray, calendarServiceDate } from '@pages/CancelSubRequests/Table/utils'

export class cancellationRequestStore extends StoreExt {
    @observable filters: { search: { [key: string]: any }; filters: { [key: string]: any } } = {
        search: {},
        filters: { status: ['OPEN'], request_reason: [], in_legal_proceedings: [] }
    }
    @observable list = []
    @observable loadingCancellationRequests = false
    @observable loadOnPaginate = false
    @observable pagination = { page: 1, perPage: 10, total: 0, lastPage: 1 }

    @action
    setSearch = (key, value) => {
        runInAction(() => {
            this.filters.search = { [key]: value }
            this.pagination = { ...this.pagination, page: 1 }
        })
    }

    @action
    setFilters = (patch?) => {
        runInAction(() => {
            if (patch && typeof patch === 'object') {
                this.filters.filters = { ...this.filters.filters, ...patch }
            } else {
                this.filters.filters = {}
            }
            this.pagination = { ...this.pagination, page: 1 }
        })
    }

    @action
    resetSearch = () => {
        runInAction(() => {
            this.filters.search = {}
            this.pagination = { ...this.pagination, page: 1 }
        })
    }

    @action
    resetFilters = () => {
        runInAction(() => {
            this.filters.filters = { status: ['OPEN'], request_reason: [], in_legal_proceedings: [] }
            this.pagination = { ...this.pagination, page: 1 }
        })
    }

    @action
    paginate = ({ page, perPage, total, lastPage }) => {
        // Use != null so a legitimate 0 (empty result set) is applied, not swallowed by ||.
        this.pagination = {
            page: page != null ? page : this.pagination.page,
            perPage: perPage != null ? perPage : this.pagination.perPage,
            total: total != null ? total : this.pagination.total,
            lastPage: lastPage != null ? lastPage : this.pagination.lastPage
        }

        this.getCancellationRequests()
    }

    // Shared by the list and the filtered export.
    buildFilterArray = () => buildCancellationFilterArray(this.filters)

    @action
    getCancellationRequests = (params = {}) => {
        const filterArray = this.buildFilterArray()

        params.withLoading === true && (this.loadingCancellationRequests = true)
        this.loadOnPaginate = true

        return cancellationRequests
            .getCancellationRequests({ filterArray, pagination: this.pagination })
            .then(res => {
                runInAction(() => {
                    this.list = res.data.cancellationRequests.data
                    const { page, perPage, lastPage, total } = res.data.cancellationRequests

                    this.pagination = { ...this.pagination, page, perPage, lastPage, total }
                    // this.setPagination({ page, perPage, lastPage, total })

                    // .sort((a, b) => {
                    //     if (this.sortHelper[a.status] > this.sortHelper[b.status]) {
                    //         return -1
                    //     } else if (this.sortHelper[a.status] < this.sortHelper[b.status]){
                    //         return 1
                    //     } else {
                    //         if (a.created_at > b.created_at) {
                    //             return -1
                    //         } else {
                    //             return 1
                    //         }
                    //     }

                    // })

                    this.loadingCancellationRequests = false
                    this.loadOnPaginate = false
                })
            })
            .catch(error => {
                console.error(error)
                runInAction(() => {
                    this.loadingCancellationRequests = false
                    this.loadOnPaginate = false
                })
            })
    }

    // 409 STATUS_CHANGED: the row changed on the server under this edit. Reload the list so the
    // operator sees the current state, as the payment-completion conflict does. True when handled.
    refreshOnConflict = error => {
        const res = error && error.response
        const isConflict = !!res && res.status === 409 && !!res.data && res.data.key === 'STATUS_CHANGED'
        if (isConflict) this.getCancellationRequests()
        return isConflict
    }

    @action
    updateCancellationRequest = payload => {
        // Single update mechanism: patch the row locally from the response instead
        // of triggering a full refetch.
        return cancellationRequests
            .updateCancellationRequest(payload)
            .then(res => {
                const request = res && res.data && res.data.cancellation_request
                if (request) this.updateListLocally({ request })
            })
            .catch(error => {
                this.refreshOnConflict(error)
                alert('אירעה שגיאה. עדכון לא בוצע')
            })
    }

    @action
    updateListLocally = ({ request }) => {
        let index = this.list.findIndex(({ id }) => id === request.id)
        if (index === -1) return
        // The list sends service_provided_date as YYYY-MM-DD; generic update responses carry the raw column (an ISO
        // UTC instant, a day early in Israel). Keep the list's value over such a form instead of shifting the day.
        const patch = { ...request }
        if (patch.service_provided_date && !calendarServiceDate(patch.service_provided_date)) {
            delete patch.service_provided_date
        }
        this.list[index] = { ...this.list[index], ...patch }
    }

    @computed
    get cancellationReqCount() {
        return this.list.filter(({ status }) => status !== 'CLOSED').length
    }

    sortHelper = {
        CLOSED: 1,
        IN_PROGRESS: 2,
        OPEN: 3
    }
}

export default new cancellationRequestStore()
